// Theme Colors
// Initially this will be blank. Later on when app is initialized we will assign bootstrap colors to this from CSS variables.
export const $themeColors = {};

// App Breakpoints
// Initially this will be blank. Later on when app is initialized we will assign bootstrap breakpoints to this object from CSS variables.
export const $themeBreakpoints = {};

// APP CONFIG
export const $themeConfig = {
  app: {
    appName: process.env.VUE_APP_NAME, // Will update name in navigation menu (Branding)
    // eslint-disable-next-line global-require
    appLogoImage:
      process.env.VUE_APP_NAME == "ILA TRAVEL"
        ? require("@/assets/images/pages/Ila_Logo.png")
        : process.env.VUE_APP_NAME == "ALSHAMS THEATER"
        ? require("@/assets/images/pages/Alahams_Logo.svg")
        : process.env.VUE_APP_NAME == "TKTFOX"
        ? require("@/assets/images/pages/Tktfox_Logo.svg")
        : process.env.VUE_APP_NAME == "RAINBOW"
        ? require("@/assets/images/pages/Rainbow_Logo.png")
        : process.env.VUE_APP_NAME == "CINEMA AIN"
        ? require("@/assets/images/pages/CinemaAin_Logo.png")
        : process.env.VUE_APP_NAME == "ART SCENE"
        ? require("@/assets/images/pages/Artscene_Logo.jpeg")
        : require("@/assets/images/logo/logo.svg"), // Will update logo in navigation menu (Branding)
  },

  layout: {
    isRTL: false,
    skin: "light", // light, dark, bordered, semi-dark
    routerTransition: "fade", // zoom-fade, slide-fade, fade-bottom, fade, zoom-out, none
    type: "vertical", // vertical, horizontal
    contentWidth: "full", // full, boxed
    menu: {
      hidden: false,
      isCollapsed: false,
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: "floating", // static , sticky , floating, hidden
      backgroundColor: "", // BS color options [primary, success, etc]
    },
    footer: {
      type: "static", // static, sticky, hidden
    },
    customizer: false,
    enableScrollToTop: true,
  },
};
